import {heroGeneral} from "./modules/sections/hero/hero-general.js";
import {fullpageScroll} from "./modules/fullpage-scroll.js";
import {mobileMenuAccordion} from "./modules/mobile-menu.js";
import {burger} from "./modules/burger.js";
import {lottieAnimation} from "./modules/lottie-animation.js";
import {contactForm} from "./modules/sections/contact.js";

document.addEventListener("DOMContentLoaded", function (event) {

    lottieAnimation();

    heroGeneral();

    fullpageScroll();

    mobileMenuAccordion();

    burger();

    contactForm();

});
